function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1956(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 17.72,
    height: 6.19,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.4761538461538462
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.86,
    y: 3.095
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 6.19,
    width: 17.72,
    height: 14.29,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.0414285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.86,
    y: 13.335
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 20.48,
    width: 17.72,
    height: 15.94,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.277142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.86,
    y: 28.45
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 36.42,
    width: 17.72,
    height: 17.55,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.19375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.86,
    y: 45.195
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 53.97,
    width: 17.72,
    height: 20.61,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.43
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.86,
    y: 64.275
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 74.58,
    width: 17.72,
    height: 23.33,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.953333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.86,
    y: 86.245
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 97.91,
    width: 17.72,
    height: 25.6,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.906666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.86,
    y: 110.71
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 123.51,
    width: 17.72,
    height: 27.5,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.953333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.86,
    y: 137.26
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 151.01,
    width: 17.72,
    height: 31.34,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7719999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.86,
    y: 166.67999999999998
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 182.35,
    width: 17.72,
    height: 32.04,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.953333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.86,
    y: 198.37
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 214.39,
    width: 17.72,
    height: 33.65,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5439999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.86,
    y: 231.21499999999997
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 248.05,
    width: 17.72,
    height: 35.02,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.953333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.86,
    y: 265.56
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 283.06,
    width: 17.72,
    height: 35.14,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.531428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.86,
    y: 300.63
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 318.2,
    width: 17.72,
    height: 35.22,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.953333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.86,
    y: 335.81
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 353.43,
    width: 17.72,
    height: 36.87,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.215
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.86,
    y: 371.865
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 390.3,
    width: 17.72,
    height: 38.77,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.531428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.86,
    y: 409.685
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 429.08,
    width: 17.72,
    height: 39.39,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.215
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.86,
    y: 448.775
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 468.47,
    width: 17.72,
    height: 43.11,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.953333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.86,
    y: 490.02500000000003
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 511.58,
    width: 17.72,
    height: 44.47,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.215
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.86,
    y: 533.8149999999999
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 556.05,
    width: 17.72,
    height: 47.2,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.531428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.86,
    y: 579.65
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 603.25,
    width: 17.72,
    height: 48.07,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.953333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.86,
    y: 627.285
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 651.32,
    width: 17.72,
    height: 48.68,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5439999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.86,
    y: 675.6600000000001
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.72,
    y: 0,
    width: 28.15,
    height: 30.65,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.021428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 31.794999999999998,
    y: 15.325
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.87,
    y: 0,
    width: 28.8,
    height: 30.65,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.114285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.269999999999996,
    y: 15.325
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.67,
    y: 0,
    width: 28.99,
    height: 30.65,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.1414285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 89.165,
    y: 15.325
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.65,
    y: 0,
    width: 29.85,
    height: 30.65,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.9750000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.575,
    y: 15.325
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 0,
    width: 30.37,
    height: 30.65,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.338571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 148.685,
    y: 15.325
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.87,
    y: 0,
    width: 30.49,
    height: 30.65,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.6225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 179.115,
    y: 15.325
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 194.36,
    y: 0,
    width: 31.04,
    height: 30.65,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.13
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 209.88000000000002,
    y: 15.325
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225.4,
    y: 0,
    width: 31.47,
    height: 30.65,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.378571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 241.135,
    y: 15.325
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.87,
    y: 0,
    width: 31.64,
    height: 30.65,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.065
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 272.69,
    y: 15.325
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288.51,
    y: 0,
    width: 31.73,
    height: 30.65,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.83125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 304.375,
    y: 15.325
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.24,
    y: 0,
    width: 31.85,
    height: 30.65,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.108333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 336.165,
    y: 15.325
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 352.09,
    y: 0,
    width: 32.5,
    height: 30.65,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.108333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 368.34,
    y: 15.325
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.59,
    y: 0,
    width: 32.69,
    height: 30.65,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4055555555555554
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 400.93499999999995,
    y: 15.325
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 417.27,
    y: 0,
    width: 34.29,
    height: 30.65,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.83125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 434.41499999999996,
    y: 15.325
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 451.56,
    y: 0,
    width: 34.53,
    height: 30.65,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.378571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 468.825,
    y: 15.325
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 486.09,
    y: 0,
    width: 35.19,
    height: 30.65,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.83125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 503.68499999999995,
    y: 15.325
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 521.28,
    y: 0,
    width: 35.24,
    height: 30.65,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.6625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 538.9,
    y: 15.325
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 556.52,
    y: 0,
    width: 35.29,
    height: 30.65,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.108333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 574.165,
    y: 15.325
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 591.81,
    y: 0,
    width: 36.01,
    height: 30.65,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.378571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 609.8149999999999,
    y: 15.325
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 627.82,
    y: 0,
    width: 36.05,
    height: 30.65,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.83125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 645.845,
    y: 15.325
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 663.87,
    y: 0,
    width: 36.13,
    height: 30.65,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.13
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 681.9350000000001,
    y: 15.325
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.72,
    y: 30.65,
    width: 35.72,
    height: 32.14,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.58,
    y: 46.72
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.72,
    y: 62.79,
    width: 35.72,
    height: 32.21,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.221
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.58,
    y: 78.895
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.72,
    y: 95,
    width: 35.72,
    height: 32.29,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.458
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.58,
    y: 111.145
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.72,
    y: 127.28,
    width: 35.72,
    height: 32.49,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.1225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.58,
    y: 143.525
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.72,
    y: 159.78,
    width: 35.72,
    height: 32.64,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.662857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.58,
    y: 176.1
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.72,
    y: 192.41,
    width: 35.72,
    height: 32.7,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.540000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.58,
    y: 208.76
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.72,
    y: 225.11,
    width: 35.72,
    height: 33.64,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.6066666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.58,
    y: 241.93
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.72,
    y: 258.75,
    width: 35.72,
    height: 34.27,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.28375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.58,
    y: 275.885
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.72,
    y: 293.02,
    width: 35.72,
    height: 34.62,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.3275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.58,
    y: 310.33
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.72,
    y: 327.65,
    width: 35.72,
    height: 34.71,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.856666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.58,
    y: 345.005
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.72,
    y: 362.35,
    width: 35.72,
    height: 35.61,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.935
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.58,
    y: 380.15500000000003
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.72,
    y: 397.96,
    width: 35.72,
    height: 35.89,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.953333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.58,
    y: 415.905
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.72,
    y: 433.85,
    width: 35.72,
    height: 37.04,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.58,
    y: 452.37
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.72,
    y: 470.89,
    width: 35.72,
    height: 37.72,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.465
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.58,
    y: 489.75
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.72,
    y: 508.61,
    width: 35.72,
    height: 38.09,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.102857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.58,
    y: 527.655
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.72,
    y: 546.7,
    width: 35.72,
    height: 38.21,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.102857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.58,
    y: 565.8050000000001
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.72,
    y: 584.9,
    width: 35.72,
    height: 38.23,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.58,
    y: 604.015
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.72,
    y: 623.13,
    width: 35.72,
    height: 38.29,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.102857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.58,
    y: 642.275
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.72,
    y: 661.42,
    width: 35.72,
    height: 38.58,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.968888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.58,
    y: 680.7099999999999
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.44,
    y: 30.65,
    width: 35.44,
    height: 39.25,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.906666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 71.16,
    y: 50.275
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.87,
    y: 30.65,
    width: 35.55,
    height: 39.25,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5549999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.64500000000001,
    y: 50.275
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.42,
    y: 30.65,
    width: 35.75,
    height: 39.25,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.958333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 142.29500000000002,
    y: 50.275
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.17,
    y: 30.65,
    width: 36.93,
    height: 39.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.386
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.635,
    y: 50.275
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.1,
    y: 30.65,
    width: 37.36,
    height: 39.25,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.226666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 215.78,
    y: 50.275
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234.46,
    y: 30.65,
    width: 37.38,
    height: 39.25,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.476000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 253.15,
    y: 50.275
  }, "\n        Peach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 271.83,
    y: 30.65,
    width: 37.54,
    height: 39.25,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.508
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 290.59999999999997,
    y: 50.275
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 309.38,
    y: 30.65,
    width: 37.75,
    height: 39.25,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.55
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 328.255,
    y: 50.275
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 347.13,
    y: 30.65,
    width: 38.01,
    height: 39.25,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 366.135,
    y: 50.275
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 385.13,
    y: 30.65,
    width: 38.2,
    height: 39.25,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.640000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 404.23,
    y: 50.275
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423.33,
    y: 30.65,
    width: 38.23,
    height: 39.25,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.371666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 442.445,
    y: 50.275
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 461.56,
    y: 30.65,
    width: 38.89,
    height: 39.25,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.7780000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 481.005,
    y: 50.275
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 500.45,
    y: 30.65,
    width: 39.09,
    height: 39.25,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.515000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 519.995,
    y: 50.275
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 539.54,
    y: 30.65,
    width: 39.69,
    height: 39.25,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.90625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 559.385,
    y: 50.275
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 579.22,
    y: 30.65,
    width: 39.76,
    height: 39.25,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.8125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 599.1,
    y: 50.275
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 618.99,
    y: 30.65,
    width: 40.12,
    height: 39.25,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.541666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 639.05,
    y: 50.275
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 659.1,
    y: 30.65,
    width: 40.9,
    height: 39.25,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.541666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 679.5500000000001,
    y: 50.275
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.44,
    y: 69.9,
    width: 42.44,
    height: 38.07,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.614
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.66,
    y: 88.935
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.44,
    y: 107.97,
    width: 42.44,
    height: 39.02,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.8775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.66,
    y: 127.48
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.44,
    y: 146.98,
    width: 42.44,
    height: 40.02,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.66,
    y: 166.98999999999998
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.44,
    y: 187,
    width: 42.44,
    height: 40.45,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.1125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.66,
    y: 207.225
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.44,
    y: 227.45,
    width: 42.44,
    height: 40.59,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.118
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.66,
    y: 247.745
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.44,
    y: 268.04,
    width: 42.44,
    height: 40.67,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.8100000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.66,
    y: 288.375
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.44,
    y: 308.71,
    width: 42.44,
    height: 40.84,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.8342857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.66,
    y: 329.13
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.44,
    y: 349.55,
    width: 42.44,
    height: 40.95,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.190000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.66,
    y: 370.02500000000003
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.44,
    y: 390.5,
    width: 42.44,
    height: 41.09,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.87
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.66,
    y: 411.045
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.44,
    y: 431.59,
    width: 42.44,
    height: 42.88,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.073333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.66,
    y: 453.03
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.44,
    y: 474.47,
    width: 42.44,
    height: 43.78,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.305
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.66,
    y: 496.36
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.44,
    y: 518.24,
    width: 42.44,
    height: 44.05,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.073333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.66,
    y: 540.265
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.44,
    y: 562.29,
    width: 42.44,
    height: 44.33,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.062857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.66,
    y: 584.4549999999999
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.44,
    y: 606.62,
    width: 42.44,
    height: 46.69,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.073333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.66,
    y: 629.965
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.44,
    y: 653.31,
    width: 42.44,
    height: 46.69,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.305
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.66,
    y: 676.655
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.88,
    y: 69.9,
    width: 42.13,
    height: 47.69,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.426
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.945,
    y: 93.745
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.01,
    y: 69.9,
    width: 43.56,
    height: 47.69,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.712
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 159.79,
    y: 93.745
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.57,
    y: 69.9,
    width: 45.46,
    height: 47.69,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.576666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 204.29999999999998,
    y: 93.745
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.04,
    y: 69.9,
    width: 45.46,
    height: 47.69,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.576666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 249.76999999999998,
    y: 93.745
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 69.9,
    width: 46.08,
    height: 47.69,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 295.54,
    y: 93.745
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 318.58,
    y: 69.9,
    width: 46.55,
    height: 47.69,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.309999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.85499999999996,
    y: 93.745
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 365.13,
    y: 69.9,
    width: 46.83,
    height: 47.69,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.6899999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 388.545,
    y: 93.745
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 411.96,
    y: 69.9,
    width: 47.75,
    height: 47.69,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.812857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 435.835,
    y: 93.745
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 459.71,
    y: 69.9,
    width: 48.01,
    height: 47.69,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.812857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 483.715,
    y: 93.745
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 507.72,
    y: 69.9,
    width: 48.04,
    height: 47.69,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.2988888888888885
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 531.74,
    y: 93.745
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 555.77,
    y: 69.9,
    width: 48.04,
    height: 47.69,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.96125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 579.79,
    y: 93.745
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 603.81,
    y: 69.9,
    width: 48.09,
    height: 47.69,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.948333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 627.8549999999999,
    y: 93.745
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 651.9,
    y: 69.9,
    width: 48.1,
    height: 47.69,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.769
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 675.9499999999999,
    y: 93.745
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.88,
    y: 117.59,
    width: 51.92,
    height: 45,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.84,
    y: 140.09
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.88,
    y: 162.58,
    width: 51.92,
    height: 45.45,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.68125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.84,
    y: 185.305
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.88,
    y: 208.03,
    width: 51.92,
    height: 45.57,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.595
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.84,
    y: 230.815
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.88,
    y: 253.6,
    width: 51.92,
    height: 46.21,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.77625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.84,
    y: 276.705
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.88,
    y: 299.81,
    width: 51.92,
    height: 47.36,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.765714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.84,
    y: 323.49
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.88,
    y: 347.18,
    width: 51.92,
    height: 47.43,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.486
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.84,
    y: 370.895
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.88,
    y: 394.61,
    width: 51.92,
    height: 49.1,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.82
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.84,
    y: 419.16
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.88,
    y: 443.71,
    width: 51.92,
    height: 49.98,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.84,
    y: 468.7
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.88,
    y: 493.69,
    width: 51.92,
    height: 50.41,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.201428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.84,
    y: 518.895
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.88,
    y: 544.1,
    width: 51.92,
    height: 50.49,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.2128571428571435
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.84,
    y: 569.345
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.88,
    y: 594.59,
    width: 51.92,
    height: 52.65,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.192
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.84,
    y: 620.9150000000001
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.88,
    y: 647.24,
    width: 51.92,
    height: 52.76,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.653333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.84,
    y: 673.62
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.8,
    y: 117.59,
    width: 50.87,
    height: 54.14,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.478333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 173.235,
    y: 144.66
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 198.67,
    y: 117.59,
    width: 51.01,
    height: 54.14,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.501666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 224.17499999999998,
    y: 144.66
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.68,
    y: 117.59,
    width: 52.1,
    height: 54.14,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.683333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 275.73,
    y: 144.66
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 301.78,
    y: 117.59,
    width: 53.24,
    height: 54.14,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.655
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 328.4,
    y: 144.66
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 355.01,
    y: 117.59,
    width: 55.18,
    height: 54.14,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.535
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 382.59999999999997,
    y: 144.66
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 410.2,
    y: 117.59,
    width: 55.21,
    height: 54.14,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.023333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 437.805,
    y: 144.66
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 465.4,
    y: 117.59,
    width: 55.87,
    height: 54.14,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.828
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 493.335,
    y: 144.66
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 521.28,
    y: 117.59,
    width: 57.02,
    height: 54.14,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.828
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 549.79,
    y: 144.66
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 578.3,
    y: 117.59,
    width: 58.32,
    height: 54.14,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.734285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 607.4599999999999,
    y: 144.66
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 636.61,
    y: 117.59,
    width: 63.39,
    height: 54.14,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.7675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 668.3050000000001,
    y: 144.66
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.8,
    y: 171.73,
    width: 61.05,
    height: 57.07,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.152857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.32500000000002,
    y: 200.265
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.8,
    y: 228.79,
    width: 61.05,
    height: 62.04,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.174999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.32500000000002,
    y: 259.81
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.8,
    y: 290.83,
    width: 61.05,
    height: 65.52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.174999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.32500000000002,
    y: 323.59
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.8,
    y: 356.35,
    width: 61.05,
    height: 66,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.783333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.32500000000002,
    y: 389.35
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.8,
    y: 422.34,
    width: 61.05,
    height: 66.53,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.721428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.32500000000002,
    y: 455.60499999999996
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.8,
    y: 488.88,
    width: 61.05,
    height: 69.06,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.174999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.32500000000002,
    y: 523.41
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.8,
    y: 557.94,
    width: 61.05,
    height: 69.1,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.63125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.32500000000002,
    y: 592.49
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.8,
    y: 627.04,
    width: 61.05,
    height: 72.96,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.721428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.32500000000002,
    y: 663.52
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.85,
    y: 171.73,
    width: 66.7,
    height: 67.68,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.34
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 242.2,
    y: 205.57
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.55,
    y: 171.73,
    width: 67.84,
    height: 67.68,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.668571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 309.47,
    y: 205.57
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.38,
    y: 171.73,
    width: 68.43,
    height: 67.68,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.46
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 377.595,
    y: 205.57
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 411.81,
    y: 171.73,
    width: 68.88,
    height: 67.68,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.280000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 446.25,
    y: 205.57
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 480.7,
    y: 171.73,
    width: 71,
    height: 67.68,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.668571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 516.2,
    y: 205.57
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 551.7,
    y: 171.73,
    width: 71.37,
    height: 67.68,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 587.385,
    y: 205.57
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 623.07,
    y: 171.73,
    width: 76.93,
    height: 67.68,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.668571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 661.5350000000001,
    y: 205.57
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.85,
    y: 239.4,
    width: 74.71,
    height: 69.83,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.72875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 246.20499999999998,
    y: 274.315
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.85,
    y: 309.23,
    width: 74.71,
    height: 72.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.026666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 246.20499999999998,
    y: 345.31
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.85,
    y: 381.39,
    width: 74.71,
    height: 73.58,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.175555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 246.20499999999998,
    y: 418.18
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.85,
    y: 454.97,
    width: 74.71,
    height: 79.96,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.6775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 246.20499999999998,
    y: 494.95000000000005
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.85,
    y: 534.93,
    width: 74.71,
    height: 82.13,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.941999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 246.20499999999998,
    y: 575.9949999999999
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.85,
    y: 617.06,
    width: 74.71,
    height: 82.94,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.30111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 246.20499999999998,
    y: 658.53
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 283.56,
    y: 239.4,
    width: 65.92,
    height: 97.02,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.48
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 316.52,
    y: 287.91
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 349.48,
    y: 239.4,
    width: 94.94,
    height: 97.02,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.988
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 396.95000000000005,
    y: 287.91
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 444.42,
    y: 239.4,
    width: 124.61,
    height: 97.02,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.1275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 506.725,
    y: 287.91
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 569.04,
    y: 239.4,
    width: 130.96,
    height: 97.02,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.1275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 634.52,
    y: 287.91
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 283.56,
    y: 336.42,
    width: 135.56,
    height: 99.91,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.9775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 351.34000000000003,
    y: 386.375
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 283.56,
    y: 436.33,
    width: 135.56,
    height: 122.79,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 30.6975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 351.34000000000003,
    y: 497.72499999999997
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 283.56,
    y: 559.13,
    width: 135.56,
    height: 140.87,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.365714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 351.34000000000003,
    y: 629.565
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 419.13,
    y: 336.42,
    width: 280.87,
    height: 120.73,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.121666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 559.565,
    y: 396.785
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 419.13,
    y: 457.15,
    width: 280.87,
    height: 242.85,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 40.475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 559.565,
    y: 578.5749999999999
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1956);
export default __webpack_public_path__ + "static/media/1956.20d50360026646a4e37f1e4ec665479b.svg";
export { ForwardRef as ReactComponent };